/* eslint-disable */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define a service using a base URL and expected endpoints
export const API = createApi({
  reducerPath: 'kifAdminApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.telesecure360.com/api/v1',
    prepareHeaders: (headers) => {
      if (localStorage.getItem('token')) headers.set('Authorization', localStorage.getItem('token'));
      return headers;
    },
  }),
  tagTypes: ['resource', 'LabOrders'],
  endpoints: (builder) => ({

    getEducationResourceCategory: builder.query({
      query: () => ({
        url: '/resource/getEducationResourceCategory',
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),

    getResources: builder.query({
      query: (params) => {
        let url = '/resource/getResources';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['resource'],
      transformResponse: (res) => res?.data?.data,
    }),
    getResourceById: builder.query({
      query: ({ id }) => ({
        url: `/resource/getResourceById/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),
    updateResourceDetails: builder.mutation({
      query: (updateData) => {
        const { id, ...body } = updateData;
        return {
          url: `/resource/updateResource/${id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['resource'],
    }),

    addResource: builder.mutation({
      query: (body) => ({
        url: '/resource/createResource',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['resource'],
    }),

    updateResourceStatus: builder.mutation({
      query: (updateData) => {
        const { id, body } = updateData;
        return {
          url: `/resource/reviewResource/${id}`,
          method: 'PUT',
          body
        };
      },
      invalidatesTags: ['resource'],
    }),
    getAdminSpecialitiesList: builder.query({
      query: () => ({
        url: '/admin/getSpecialitiesList',
        method: 'GET',
        params: {
          limit: 10000000,
          isForAdminList: 1,
        },
      }),
      transformResponse: (res) => res.data.speciality,
    }),
    getEducationResourceCategory: builder.query({
      query: () => ({
        url: '/resource/getEducationResourceCategory',
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),
    getDoctorResourceStats: builder.query({
      query: () => ({
        url: '/resource/getDoctorResourceStats',
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),
    deleteResource: builder.mutation({
      query: (updateData) => {
        const { id } = updateData;
        return {
          url: `/resource/deleteResource/${id}`,
          method: 'DELETE',
          // body
        };
      },
      invalidatesTags: ['resource'],
    }),
    getDoctorResourcesNotification: builder.query({
      query: (params) => {
        let url = '/resource/getDoctorResourceNotification';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      // providesTags: ['resource'],
      transformResponse: (res) => res?.data,
    }),
    getLabsList: builder.query({
      query: (params) => {
        let url = '/admin/getLabsList';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (res) => res?.data?.data,
    }),
    getPanelList: builder.query({
      query: (params) => {
        let url = '/lab/getPanelsList';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (res) => res?.data?.data,
    }),
    getBookingDetails: builder.query({
      query: (params) => {
        let url = '/booking/getBookingDetails';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (res) => res?.data,
    }),
    getLinkedPanels: builder.query({
      query: ({ labId }) => ({
        url: `/doctor/getLinkedPanels/${labId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data?.data,
    }),
    createLabOrder: builder.mutation({
      query: ({ body }) => ({
        url: '/doctor/createLabOrder',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LabOrders'],
    }),
    getLabOrders: builder.query({
      query: (params) => {
        let url = '/lab/orders';
        if (params) {
          const queryString = new URLSearchParams(params).toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (res) => res?.data?.data,
      providesTags: ['LabOrders'],
    }),
    getLabOrdersById: builder.query({
      query: ({ id }) => ({
        url: `/lab/orders/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useGetEducationResourceCategoryQuery,
  useGetResourcesQuery,
  useLazyGetResourcesQuery,
  useGetResourceByIdQuery,
  useLazyGetResourceByIdQuery,
  useUpdateResourceDetailsMutation,
  useAddResourceMutation,
  useUpdateResourceStatusMutation,
  useGetAdminSpecialitiesListQuery,
  useLazyGetEducationResourceCategoryQuery,
  useGetDoctorResourceStatsQuery,
  useDeleteResourceMutation,
  useGetDoctorResourcesNotificationQuery,
  useGetLabsListQuery,
  useLazyGetLabsListQuery,
  useGetPanelListQuery,
  useLazyGetPanelListQuery,
  useGetBookingDetailsQuery,
  useLazyGetBookingDetailsQuery,
  useGetLinkedPanelsQuery,
  useLazyGetLinkedPanelsQuery,
  useCreateLabOrderMutation,
  useGetLabOrdersQuery,
  useLazyGetLabOrdersQuery,
  useGetLabOrdersByIdQuery,
  useLazyGetLabOrdersByIdQuery,
} = API;
